import { render, staticRenderFns } from "./createNwSaleOrder.vue?vue&type=template&id=9c8d7d04&scoped=true"
import script from "./createNwSaleOrder.vue?vue&type=script&lang=js"
export * from "./createNwSaleOrder.vue?vue&type=script&lang=js"
import style0 from "./createNwSaleOrder.vue?vue&type=style&index=0&id=9c8d7d04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c8d7d04",
  null
  
)

export default component.exports